<template>
  <div class="hero d-flex justify-center">
    <div class="sistema-container">
      <div class="sistema-layout">
        <!-- Main content (left side) -->
        <div class="sistema-content">
          <div class="sistema-header">
            <span class="event-eyebrow">Entrenamiento en</span>
            <h1 class="sistema-title">
              Desmantelamiento de Laboratorios Clandestinos de Drogas Ilícitas
            </h1>
            <h2 class="curso-title">San Juan 2026</h2>
            <div class="header-divider"></div>
          </div>

          <div class="controls-container">
            <div class="switch-wrapper">
              <div class="switch-container">
                <v-switch
                  v-model="entrada"
                  inset
                  color="#d4a72c"
                  :label="`TIPO: ${entrada ? 'ENTRADA' : 'SALIDA'}`"
                  dark
                  hide-details
                  class="modern-switch"
                >
                </v-switch>
                <div class="f3-indicator">
                  <v-chip
                    x-small
                    color="#d4a72c"
                    text-color="#12133f"
                    class="f3-chip"
                  >
                    <v-icon small left>mdi-keyboard</v-icon>
                    F3
                  </v-chip>
                </div>
              </div>
            </div>

            <div class="input-wrapper">
              <v-text-field
                class="modern-input"
                ref="miInput"
                v-model="valorCodigo"
                v-on:keyup.enter="actualizarLista()"
                autofocus
                type="password"
                label="Scanner DNI (F2)"
                color="#d4a72c"
                dark
                outlined
                append-icon="mdi-barcode-scan"
                hide-details
              ></v-text-field>

              <!-- Manual entry hint -->
              <div class="help-message">
                <v-icon small color="#d4a72c" class="help-icon"
                  >mdi-information-outline</v-icon
                >
                <span class="help-text">
                  Presiona
                  <v-chip
                    x-small
                    color="#d4a72c"
                    text-color="#12133f"
                    class="key-chip"
                  >
                    <v-icon x-small left>mdi-keyboard</v-icon>
                    F4
                  </v-chip>
                  para carga manual
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Ministry seal (right side) -->
        <div class="ministerio-logo-container">
          <div class="escudo-glow"></div>
          <v-img
            src="@/assets/img/escudo-ministerio-seguridad.png"
            class="escudo-logo"
            contain
            max-width="340"
            max-height="340"
          ></v-img>
        </div>
      </div>
    </div>

    <!-- Institutional footer -->
    <footer class="hero-footer">
      <div class="footer-logos">
        <img
          src="@/assets/img/logo-gobierno.jpeg"
          alt="Gobierno de San Juan - Secretaría de Estado de Seguridad y Orden Público"
          class="footer-logo footer-logo--dark-bg footer-logo--gobierno"
        />
        <img
          src="@/assets/img/logo-presidencia.jpeg"
          alt="Presidencia de la Nación"
          class="footer-logo footer-logo--mono footer-logo--presidencia"
        />
        <img
          src="@/assets/img/logo-ministerio-seguridad-nacional.jpeg"
          alt="Ministerio de Seguridad Nacional - República Argentina"
          class="footer-logo footer-logo--dark-bg footer-logo--ministerio"
        />
        <img
          src="@/assets/img/logo-policia.jpeg"
          alt="Policía de San Juan"
          class="footer-logo footer-logo--dark-bg footer-logo--policia"
        />
        <img
          src="@/assets/img/logo-d8.jpeg"
          alt="D-8 Dirección de Telecomunicaciones y Emergencias Policiales"
          class="footer-logo footer-logo--dark-bg footer-logo--d8"
        />
      </div>
    </footer>

    <v-dialog v-model="dialog" width="700">
      <v-card class="respuesta-card" dark>
        <div class="respuesta-header">
          <v-img
            src="@/assets/img/escudo-ministerio-seguridad.png"
            class="respuesta-escudo"
            contain
            max-width="120"
            max-height="120"
          ></v-img>
        </div>
        <v-card-title class="respuesta-title">
          <span class="titulo-card">{{ respuesta.mensaje }}</span>
        </v-card-title>
        <v-card-text class="respuesta-nombre">
          {{ respuesta.nombre || " " }}
        </v-card-text>
      </v-card>
    </v-dialog>

    <CargaManual
      :handleDialog="dialogForm"
      :entrada="entrada"
      @cerrarForm="handleForm"
      @handleDialogRespuesta="handleDialogRespuesta"
    />
  </div>
</template>

<script>
// import { json } from 'body-parser';
import axios from "axios";

import CargaManual from "../components/cargaManual.vue";

export default {
  components: {
    CargaManual,
  },
  data() {
    return {
      entrada: true,
      dialogForm: false,
      pantalla: "",

      dialog: false,

      valorCodigo: "",
      dniInput: "",
      datos: {},
      respuesta: "",
      dni: "",
      nombre: "",
      message: "",
      apellido: "",
    };
  },

  created() {
    //  this.$refs.miInput.$el.focus()
    this.pantalla = screen.height;
    console.log("pantalla", this.pantalla);
  },

  mounted() {
    // Agregar event listener para las teclas F2, F3 y F4
    this.handleKeyDown = (event) => {
      if (event.key === "F3") {
        // Prevenir el comportamiento predeterminado del navegador
        event.preventDefault();
        // Cambiar el estado del switch cuando se presiona F3
        this.entrada = !this.entrada;
        // Mantener el foco en el campo de entrada
        this.$refs.miInput.focus();
      } else if (event.key === "F2") {
        // Prevenir el comportamiento predeterminado del navegador
        event.preventDefault();
        // Hacer focus en el campo de código de barras
        this.$refs.miInput.focus();
      } else if (event.key === "F4") {
        // Prevenir el comportamiento predeterminado del navegador
        event.preventDefault();
        // Alternar el diálogo de carga manual (abrir si está cerrado, cerrar si está abierto)
        this.handleForm(!this.dialogForm);
      }
    };
    window.addEventListener("keydown", this.handleKeyDown);
  },

  beforeDestroy() {
    // Eliminar el event listener cuando el componente se destruye
    window.removeEventListener("keydown", this.handleKeyDown);
  },

  methods: {
    handleDialogRespuesta(item) {
      console.log("handleDialogRespuesta", item);
      let tiempo = item.tiempo;
      console.log("handleDialogRespuesta", item);
      this.handleDialogInfo(item, tiempo);
      // this.dialog = item;
    },
    handleForm(item) {
      console.log("handleForm", item);
      if (item == false) {
        this.dialogForm = false;
      } else {
        this.dialogForm = true;
      }
    },
    async actualizarLista() {
      console.log("valorCodigo", this.valorCodigo);

      let datosPersonales = {
        nombre: "",
        dni: "",
      };

      try {
        // Verificar si el código contiene un patrón específico para el primer formato
        if (
          this.valorCodigo.startsWith("0") &&
          this.valorCodigo.split('"').length >= 8
        ) {
          // Procesar el primer tipo de código
          this.datos = this.valorCodigo.split('"');
          console.log("datos en el if", this.datos);

          if (this.datos.length >= 5) {
            // Asegura que hay suficientes partes en el array
            datosPersonales.dni = this.datos[4];
            datosPersonales.nombre = this.datos[1] + " " + this.datos[2];
          } else {
            throw new Error("Formato inválido para el primer tipo de código.");
          }
        } else if (this.valorCodigo.split('"').length >= 6) {
          // Procesar el segundo tipo de código
          this.datos = this.valorCodigo.split('"');
          console.log("datos en el else", this.datos);

          if (this.datos.length >= 6) {
            // Asegura que hay suficientes partes en el array
            datosPersonales.dni = this.datos[1].trim();
            datosPersonales.nombre = this.datos[4] + " " + this.datos[5];
          } else {
            throw new Error("Formato inválido para el segundo tipo de código.");
          }
        } else {
          throw new Error(
            "El código proporcionado no coincide con ningún formato válido."
          );
        }

        // Validar los datos extraídos
        const dniValido = /^\d{7,8}$/.test(datosPersonales.dni); // Verifica si el DNI es numérico y tiene entre 7 u 8 dígitos
        const nombreValido =
          datosPersonales.nombre &&
          datosPersonales.nombre.trim().length > 0 &&
          /^[a-zA-Z\s]+$/.test(datosPersonales.nombre); // Verifica que el nombre no esté vacío y contenga solo letras y espacios

        if (dniValido && nombreValido) {
          console.log("datosPersonales válidos", datosPersonales);
          // Aquí puedes proceder a enviar el objeto `datosPersonales`
          datosPersonales.entrada = this.entrada ? 1 : 0;
          await axios
            .post(
              process.env.VUE_APP_BACKEND_ENVIRONMENT + "validar/acreditar",
              {
                ...datosPersonales,
              }
            )
            .then((res) => {
              console.log("res", res);
              this.handleDialogInfo(res.data, 4000);
              // console.log(this.respuesta);
              // this.nombre = res.data.nombre;
              // this.message = res.data.mensaje;
            })
            .catch((e) => {
              this.handleDialogInfo(e.response.data, 8000);
              console.log(e);
              // this.message = e.response.data.mensaje;
            });
        } else {
          console.error("Error: Datos personales inválidos", datosPersonales);
          // Manejo de error si los datos son inválidos
        }
      } catch (error) {
        console.error("Error al procesar el código:", error.message);
        // Mostrar un mensaje de error amigable al usuario o realizar otra acción de manejo de error
      }
      console.log("datosPersonales", datosPersonales);
    },
    handleDialogInfo(info, tiempo) {
      console.log("handleDialogInfooooo", info, tiempo);
      this.dialog = true;

      this.respuesta = info;
      setTimeout(() => {
        this.dialog = false;
        (this.valorCodigo = ""), (this.respuesta = "");
      }, tiempo);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,500;0,700;1,500&display=swap");

:root {
  --navy-900: #12133f;
  --navy-800: #1c1d5a;
  --navy-700: #26287a;
  --gold-500: #d4a72c;
  --gold-300: #e9c45c;
  --text-muted: rgba(255, 255, 255, 0.72);
}

/* Full-screen backdrop */
.hero {
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background-color: var(--navy-800);
  background-image: radial-gradient(
      ellipse at 20% 20%,
      rgba(212, 167, 44, 0.12) 0%,
      transparent 55%
    ),
    radial-gradient(
      ellipse at 80% 80%,
      rgba(38, 40, 122, 0.9) 0%,
      transparent 60%
    ),
    linear-gradient(160deg, var(--navy-800) 0%, var(--navy-900) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Institutional footer */
.hero-footer {
  width: 100%;
  flex-shrink: 0;
  padding: 14px 24px 18px;
  background: linear-gradient(
    180deg,
    rgba(18, 19, 63, 0) 0%,
    rgba(10, 11, 40, 0.85) 100%
  );
  border-top: 1px solid rgba(212, 167, 44, 0.25);
}

.footer-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 28px;
}

.footer-logo {
  height: 56px;
  width: auto;
  object-fit: contain;
}

/* JPEG exports with a baked-in black background: screen blend drops the black */
.footer-logo--dark-bg {
  mix-blend-mode: screen;
}

/* Single-color navy logo on transparent background: render it white */
.footer-logo--mono {
  filter: brightness(0) invert(1);
}

.footer-logo--gobierno {
  height: 40px;
}

/* Artwork fills only the top 81% of this canvas; scale up and nudge down to align */
.footer-logo--presidencia {
  height: 58px;
  transform: translateY(5px);
}

.footer-logo--ministerio {
  height: 56px;
}

.footer-logo--policia {
  height: 40px;
}

/* The D-8 asset is a 16:9 canvas with empty bands above and below the artwork; cover-crop them */
.footer-logo--d8 {
  width: 187px;
  height: 56px;
  object-fit: cover;
  object-position: center;
}

@media (max-width: 960px) {
  .hero {
    height: auto;
    min-height: 100vh;
  }

  .footer-logos {
    gap: 20px;
  }

  .footer-logo,
  .footer-logo--ministerio {
    height: 36px;
  }

  .footer-logo--gobierno {
    height: 26px;
  }

  .footer-logo--d8 {
    width: 120px;
    height: 36px;
  }
}

/* Main kiosk card */
.sistema-container {
  margin: auto;
  width: 860px;
  padding: 36px 40px;
  background-color: rgba(18, 19, 63, 0.72);
  border-radius: 20px;
  border: 1px solid rgba(212, 167, 44, 0.35);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transform: scale(1.05);
}

.sistema-layout {
  display: flex;
  align-items: center;
  gap: 32px;
  min-height: 360px;
}

.sistema-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

/* Header */
.sistema-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 26px;
}

.event-eyebrow {
  color: var(--gold-300);
  font-family: "Lora", Georgia, serif;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.sistema-title {
  color: #ffffff;
  font-family: "Lora", Georgia, serif;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.25;
  margin: 0;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
}

.curso-title {
  color: var(--gold-500);
  font-family: "Lora", Georgia, serif;
  font-size: 1.5rem;
  font-style: italic;
  font-weight: 500;
  line-height: 1.3;
  margin: 10px 0 0 0;
  letter-spacing: 0.5px;
}

.header-divider {
  width: 64px;
  height: 3px;
  margin-top: 16px;
  border-radius: 2px;
  background: linear-gradient(90deg, transparent, var(--gold-500), transparent);
}

/* Ministry seal */
.ministerio-logo-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 340px;
  height: 340px;
}

.escudo-glow {
  position: absolute;
  inset: 10%;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(212, 167, 44, 0.28) 0%,
    rgba(212, 167, 44, 0) 70%
  );
  filter: blur(18px);
}

.escudo-logo {
  position: relative;
  filter: drop-shadow(0 12px 28px rgba(0, 0, 0, 0.6));
}

/* Controls */
.controls-container {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.switch-wrapper,
.input-wrapper {
  width: 100%;
}

.switch-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: fit-content;
}

.f3-indicator {
  position: absolute;
  top: -10px;
  right: -18px;
}

.f3-chip {
  font-size: 10px;
  font-weight: 700;
  height: 20px !important;
}

.modern-switch {
  margin: 0 auto;
}

.modern-switch .v-label {
  color: #ffffff !important;
  font-weight: 600;
  letter-spacing: 1px;
}

.modern-input .v-label {
  font-weight: 500;
}

.modern-input.v-text-field--outlined fieldset {
  border-color: rgba(212, 167, 44, 0.45);
}

/* Manual entry hint */
.help-message {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 14px;
  padding: 10px 16px;
  background: rgba(212, 167, 44, 0.08);
  border: 1px solid rgba(212, 167, 44, 0.3);
  border-radius: 10px;
}

.help-icon {
  margin-right: 8px;
}

.help-text {
  color: var(--text-muted);
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  text-align: center;
  line-height: 1.4;
}

.key-chip {
  margin: 0 4px;
  font-weight: 700;
}

/* Response dialog */
.respuesta-card {
  background: linear-gradient(
    160deg,
    var(--navy-800) 0%,
    var(--navy-900) 100%
  ) !important;
  border: 1px solid rgba(212, 167, 44, 0.4);
  border-radius: 16px !important;
}

.respuesta-header {
  display: flex;
  justify-content: center;
  padding: 28px 0 8px;
}

.respuesta-escudo {
  filter: drop-shadow(0 8px 20px rgba(0, 0, 0, 0.6));
}

.respuesta-title {
  justify-content: center;
  padding-bottom: 4px !important;
}

.respuesta-title .titulo-card {
  font-family: "Lora", Georgia, serif;
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--gold-300);
  text-align: center;
  width: 100%;
  word-break: normal;
}

.respuesta-nombre {
  font-family: "Lora", Georgia, serif;
  font-size: 2.75rem !important;
  line-height: 1.2;
  text-align: center;
  color: #ffffff !important;
  padding-bottom: 32px !important;
}

/* Responsive */
@media (max-width: 960px) {
  .sistema-container {
    width: calc(100vw - 32px);
    padding: 24px;
    transform: none;
  }

  .sistema-layout {
    flex-direction: column-reverse;
    gap: 16px;
    min-height: 0;
  }

  .ministerio-logo-container {
    width: 200px;
    height: 200px;
  }

  .escudo-logo {
    max-width: 200px !important;
    max-height: 200px !important;
  }

  .sistema-title {
    font-size: 1.35rem;
  }

  .curso-title {
    font-size: 1.2rem;
  }
}

@media (max-width: 600px) {
  .help-text {
    font-size: 0.8rem;
    flex-direction: column;
    gap: 4px;
  }

  .key-chip {
    margin: 2px 0;
  }

  .respuesta-nombre {
    font-size: 1.75rem !important;
  }
}
</style>

<style>
label {
  font-size: 1.2rem !important;
  font-weight: bold;
}
</style>
